export default "__VITE_ASSET__DBQoALvD__"